import component from './Cart.vue'

export { default as ExtraList } from './components/ExtraList.vue'
export { default as MenuList } from './components/MenuList.vue'
export { default as MenuItem } from './components/MenuItem.vue'
export { default as ProductItem } from './components/ProductItem.vue'

export default component
